import { ICommonCampaignRow } from '../types/global';

import axios, { API_URL } from './config';

export const createAnnotationAPI = async (
  text: string,
  row: ICommonCampaignRow,
): Promise<{ data: { id: string } }> =>
  axios.post(`${API_URL}/annotations/${row.domain}`, {
    text,
    campaign: row.campaign,
    ...(row.offer ? { offer: row.offer } : {}),
  });

export const updateAnnotationAPI = async (text: string, row: ICommonCampaignRow) =>
  axios.put(`${API_URL}/annotations/${row.domain}/${row.annotationId}`, { text });

export const removeAnnotationAPI = async (row: ICommonCampaignRow) =>
  axios.delete(`${API_URL}/annotations/${row.domain}/${row.annotationId}`);
